import { createContext, useContext } from "react"
import { Config } from "../types"
import { Dispatch } from "../stores/reducer"

type DonationFormContextType = {
  config: Config
  dispatch: Dispatch
}

export const DonationFormContext = createContext<
  DonationFormContextType | undefined
>(undefined)

export function useDonationFormContext() {
  const context = useContext(DonationFormContext)
  if (context === undefined) {
    throw new Error(
      "useDonationFormContext must be used within a DonationFormContextProvider",
    )
  }
  return context
}
